(function () {
  var PRODUCT_WIDGET_SELECTOR = '[data-townwine-collector-stats]';
  var SUMMARY_WIDGET_SELECTOR = '[data-townwine-collector-summary]';
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var followRefreshTimer = null;

  function normalizeProxyBase(value) {
    var trimmedValue = String(value || '').trim();

    if (!trimmedValue) {
      return DEFAULT_PROXY_BASE;
    }

    return trimmedValue.endsWith('/') ? trimmedValue.slice(0, -1) : trimmedValue;
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function getProductWidgets(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(PRODUCT_WIDGET_SELECTOR));
  }

  function getSummaryWidgets(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(SUMMARY_WIDGET_SELECTOR));
  }

  function getSummaryWidgetMatchHandles(widget) {
    var aliases = [];
    var extraHandles = String(widget.dataset.collectorMatchHandles || '')
      .split(',')
      .map(normalizeHandle)
      .filter(Boolean);
    var primaryHandle = normalizeHandle(widget.dataset.influencerHandle || '');

    [primaryHandle]
      .concat(extraHandles)
      .forEach(function (value) {
        if (value && aliases.indexOf(value) === -1) {
          aliases.push(value);
        }
      });

    return aliases;
  }

  function collectGroups(root) {
    var groups = new Map();

    getProductWidgets(root || document).forEach(function (widget) {
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      var productId = String(widget.dataset.productId || '').trim();

      if (!productId) {
        return;
      }

      var proxyBase = normalizeProxyBase(widget.dataset.proxyBase);
      var group = groups.get(proxyBase) || {
        productWidgets: [],
        summaryWidgets: [],
        productIds: new Set(),
        handles: new Set(),
      };

      group.productWidgets.push(widget);
      group.productIds.add(productId);
      groups.set(proxyBase, group);
    });

    getSummaryWidgets(root || document).forEach(function (widget) {
      if (!(widget instanceof HTMLElement)) {
        return;
      }

      var handles = getSummaryWidgetMatchHandles(widget);

      if (!handles.length) {
        return;
      }

      var proxyBase = normalizeProxyBase(widget.dataset.proxyBase);
      var group = groups.get(proxyBase) || {
        productWidgets: [],
        summaryWidgets: [],
        productIds: new Set(),
        handles: new Set(),
      };

      group.summaryWidgets.push(widget);
      handles.forEach(function (handle) {
        group.handles.add(handle);
      });
      groups.set(proxyBase, group);
    });

    return groups;
  }

  function setText(scope, selector, value) {
    scope.querySelectorAll(selector).forEach(function (element) {
      if (element instanceof HTMLElement) {
        element.textContent = value;
      }
    });
  }

  function formatInteger(value) {
    var safeValue = Number(value);

    if (!Number.isFinite(safeValue)) {
      return '0';
    }

    return new Intl.NumberFormat('ko-KR').format(Math.max(0, Math.trunc(safeValue)));
  }

  function getDealsLabel(widget, snapshot) {
    if (!(widget instanceof HTMLElement) || !snapshot) {
      return '누적 공구 0회';
    }

    var dealsFormat = String(widget.dataset.dealsFormat || '').trim();

    if (dealsFormat) {
      return dealsFormat.replace('{count}', formatInteger(snapshot.dealCount || 0));
    }

    return snapshot.dealsLabel || '누적 공구 0회';
  }

  function applySnapshot(widget, snapshot) {
    if (!(widget instanceof HTMLElement) || !snapshot) {
      return;
    }

    widget.dataset.followerCount = String(snapshot.followerCount || 0);
    widget.dataset.dealCount = String(snapshot.dealCount || 0);

    var collectorCard = widget.closest('[data-collector-card]');
    if (collectorCard instanceof HTMLElement) {
      collectorCard.dataset.followerCount = String(snapshot.followerCount || 0);
      collectorCard.dataset.dealCount = String(snapshot.dealCount || 0);
    }

    setText(widget, '[data-collector-followers]', snapshot.followersLabel || '0 팔로워');
    setText(widget, '[data-collector-deals]', getDealsLabel(widget, snapshot));
  }

  function fetchSnapshots(proxyBase, productIds, handles) {
    var url = new URL(proxyBase + '/collector-stats', window.location.origin);

    productIds.forEach(function (productId) {
      url.searchParams.append('productId', productId);
    });

    handles.forEach(function (handle) {
      url.searchParams.append('handle', handle);
    });

    return fetch(url.toString(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('COLLECTOR_STATS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function refresh(root) {
    var groups = collectGroups(root || document);

    groups.forEach(function (group, proxyBase) {
      var productIds = Array.from(group.productIds);
      var handles = Array.from(group.handles);

      if (!productIds.length && !handles.length) {
        return;
      }

      fetchSnapshots(proxyBase, productIds, handles)
        .then(function (payload) {
          var snapshots = (payload && payload.snapshots) || {};

          group.productWidgets.forEach(function (widget) {
            if (!(widget instanceof HTMLElement)) {
              return;
            }

            var productId = String(widget.dataset.productId || '').trim();
            applySnapshot(widget, snapshots[productId]);
          });

          group.summaryWidgets.forEach(function (widget) {
            if (!(widget instanceof HTMLElement)) {
              return;
            }

            var matchedHandle = getSummaryWidgetMatchHandles(widget).find(function (handle) {
              return Boolean(snapshots[handle]);
            });

            applySnapshot(
              widget,
              snapshots[matchedHandle || normalizeHandle(widget.dataset.influencerHandle || '')],
            );
          });

          document.dispatchEvent(
            new CustomEvent('townwine:collector-stats-updated', {
              detail: {
                proxyBase: proxyBase,
              },
            }),
          );
        })
        .catch(function (error) {
          console.warn('[collector-stats] failed to fetch snapshots', error);
        });
    });
  }

  function initialize(root) {
    refresh(root || document);
  }

  function scheduleFollowRefresh() {
    if (followRefreshTimer) {
      window.clearTimeout(followRefreshTimer);
    }

    followRefreshTimer = window.setTimeout(function () {
      followRefreshTimer = null;
      refresh(document);
    }, 1200);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('townwine:follow-change', function () {
    refresh(document);
    scheduleFollowRefresh();
  });

  window.TownWineCollectorStats = {
    init: initialize,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
    return;
  }

  initialize(document);
})();
